import React, { useState, useEffect, useMemo } from 'react';
import { http, getAuthorizationHeader, imageBaseUrl } from '../../config/http';
import Layouts from '../../layouts/Layouts';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import {
  IconCheck,
  IconX,
  IconEye,
  IconSearch,
  IconBuildingStore,
  IconAlertCircle,
  IconAlertTriangle,
  IconCalendarTime,
  IconReload,
  IconPhoto,
  IconInbox,
  IconChartPie,
  IconListDetails,
  IconUser,
  IconCircleCheck,
  IconClock,
  IconChevronLeft,
  IconChevronRight,
} from '@tabler/icons-react';
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css'; 
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import { toast } from 'react-toastify';
import PinBrankas from '../../components/Admin/PinBrankas';

const VerifikasiPermohonanBrankas = () => {
  const token = localStorage.getItem('token');

  const [permohonans, setPermohonans] = useState([]);
  const [loading, setLoading] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [totalPermohonan, setTotalPermohonan] = useState(0);
  const [pageInput, setPageInput] = useState('1');

  useEffect(() => {
    setPageInput(page.toString());
  }, [page]);

  const jumpToPage = () => {
    const p = parseInt(pageInput, 10);
    if (!isNaN(p) && p >= 1 && p <= lastPage) {
      setPage(p);
    } else {
      setPageInput(page.toString());
    }
  };

  // Date Filter State
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const selectionRange = {
    startDate: startDate || new Date(),
    endDate: endDate || new Date(),
    key: 'selection',
  };

  const handleSelectDate = (date) => {
    setStartDate(date.selection.startDate);
    setEndDate(date.selection.endDate);
    setPage(1);
  };

  const awal = startDate ? moment(startDate).format('DD-MM-YYYY') : '';
  const akhir = endDate ? moment(endDate).format('DD-MM-YYYY') : '';

  // Detail Modal State
  const [selectedPermohonan, setSelectedPermohonan] = useState(null);
  const [isOpenDetailModal, setIsOpenDetailModal] = useState(false);
  const [modalTab, setModalTab] = useState('ringkasan');
  const [searchModalItem, setSearchModalItem] = useState('');

  // Verification Action Modal State
  const [isOpenVerificationModal, setIsOpenVerificationModal] = useState(false);
  const [verifyingPermohonan, setVerifyingPermohonan] = useState(null);
  const [actionType, setActionType] = useState('disetujui');
  const [catatanVerifikasi, setCatatanVerifikasi] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPinModalVerification, setShowPinModalVerification] = useState(false);

  const [selectedUser, setSelectedUser] = useState('');
  const [selectedCabang, setSelectedCabang] = useState('');
  const [userList, setUserList] = useState([]);
  const [cabangList, setCabangList] = useState([]);

  // Detail Image Modal State (Paginated)
  const [isOpenImageModal, setIsOpenImageModal] = useState(false);
  const [selectedImagePermohonan, setSelectedImagePermohonan] = useState(null);
  const [imageItems, setImageItems] = useState([]);
  const [imagePage, setImagePage] = useState(1);
  const [imageLastPage, setImageLastPage] = useState(1);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [totalModalPermohonan, setTotalModalPermohonan] = useState(0);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const resUser = await http.get('users', { headers: { Authorization: getAuthorizationHeader() } });
        const users = resUser.data.data || resUser.data;
        // Assume users array has role info, filter to operator_rumah
        setUserList(Array.isArray(users) ? users.filter(u => u.role && u.role.includes('operator_rumah')) : []);

        const resCabang = await http.get('cabang', { headers: { Authorization: getAuthorizationHeader() } });
        const cabangs = resCabang.data.data || resCabang.data;
        // Transform "Etalase" to "Brankas" for dropdown display
        setCabangList(Array.isArray(cabangs) ? cabangs.map(c => ({...c, nama_cabang: c.nama_cabang ? c.nama_cabang.replace(/Etalase/gi, 'Brankas') : c.nama_cabang})) : []);
      } catch (err) {
        console.error(err);
      }
    };
    fetchOptions();
  }, [token]);

  const fetchPermohonanList = async () => {
    setLoading(true);
    try {
      let url = `permohonan-brankas?page=${page}&per_page=10`;
      if (statusFilter) url += `&status=${statusFilter}`;
      if (search) url += `&search=${search}`;
      if (selectedUser) url += `&user_pemohon_id=${selectedUser}`;
      if (selectedCabang) url += `&cabang_asal_id=${selectedCabang}`;
      if (startDate && endDate) {
        url += `&start_date=${moment(startDate).format('YYYY-MM-DD')}&end_date=${moment(endDate).format('YYYY-MM-DD')}`;
      }

      const res = await http.get(url, {
        headers: { Authorization: getAuthorizationHeader() }
      });
      if (res.data.status) {
        setPermohonans(res.data.data.data || []);
        setLastPage(res.data.data.last_page || 1);
        setTotalPermohonan(res.data.data.total || 0);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPermohonanList();
  }, [page, statusFilter, search, startDate, endDate, selectedUser, selectedCabang]);

  const fetchImageItems = async (permohonanId, pageNum) => {
    setIsImageLoading(true);
    try {
      const res = await http.get(`permohonan-brankas/${permohonanId}/items?page=${pageNum}&per_page=10`, {
        headers: { Authorization: getAuthorizationHeader() }
      });
      if (res.data.status) {
        setImageItems(res.data.data.data || []);
        setImageLastPage(res.data.data.last_page || 1);
        setTotalModalPermohonan(res.data.total_modal || 0);
      }
    } catch (error) {
      console.error(error);
      toast.error('Gagal mengambil data item gambar');
    } finally {
      setIsImageLoading(false);
    }
  };

  useEffect(() => {
    if (selectedImagePermohonan) {
      fetchImageItems(selectedImagePermohonan.id, imagePage);
    }
  }, [selectedImagePermohonan, imagePage]);

  const handleOpenImageModal = (permohonan) => {
    setSelectedImagePermohonan(permohonan);
    setImagePage(1);
    setIsOpenImageModal(true);
  };

  const handleOpenDetail = async (id) => {
    try {
      const res = await http.get(
        `permohonan-brankas/${id}`,
        { headers: { Authorization: getAuthorizationHeader() } }
      );
      if (res.data.status) {
        setSelectedPermohonan(res.data.data);
        setModalTab('ringkasan');
        setSearchModalItem('');
        setIsOpenDetailModal(true);
      }
    } catch (err) {
      console.error(err);
      toast.error('Gagal memuat detail permohonan');
    }
  };

  // Memoized Detail Summary
  const detailSummary = useMemo(() => {
    if (!selectedPermohonan || !selectedPermohonan.items) return {};
    
    return selectedPermohonan.items.reduce((acc, item) => {
      const catName = item.jenis_kategori?.kategori?.nama_kategori || 'Tanpa Kategori';
      const karat = item.karat || '-';
      const berat = parseFloat(item.berat || 0);

      if (!acc[catName]) {
        acc[catName] = { name: catName, pcs: 0, berat: 0, byKarat: {} };
      }
      
      acc[catName].pcs += 1;
      acc[catName].berat += berat;

      if (!acc[catName].byKarat[karat]) {
        acc[catName].byKarat[karat] = { pcs: 0, berat: 0 };
      }

      acc[catName].byKarat[karat].pcs += 1;
      acc[catName].byKarat[karat].berat += berat;

      return acc;
    }, {});
  }, [selectedPermohonan]);

  const resolveItemImageUrl = (item) => {
    if (!item) return '';
    let gData = item.gambar1 || item.gambar;
    if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
      try {
        gData = JSON.parse(gData);
      } catch (e) {}
    }
    if (Array.isArray(gData) && gData.length > 0) {
      const path = gData[0]?.asli || gData[0]?.thumbnail || (typeof gData[0] === 'string' ? gData[0] : '');
      return path ? (path.startsWith('http') ? path : `${imageBaseUrl}${path}`) : '';
    }
    if (typeof gData === 'string' && gData.length > 0) {
      return gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
    }
    return '';
  };

  const filteredModalItems = useMemo(() => {
    if (!selectedPermohonan || !selectedPermohonan.items) return [];
    if (!searchModalItem.trim()) return selectedPermohonan.items;
    const q = searchModalItem.toLowerCase();
    return selectedPermohonan.items.filter((it) => {
      const kode = it.kode_item ? it.kode_item.toLowerCase() : '';
      const jenis = it.jenis_kategori?.nama_jenis ? it.jenis_kategori.nama_jenis.toLowerCase() : '';
      const kat = it.jenis_kategori?.kategori?.nama_kategori ? it.jenis_kategori.kategori.nama_kategori.toLowerCase() : '';
      const baki = it.nomor_rak ? it.nomor_rak.toString().toLowerCase() : '';
      return kode.includes(q) || jenis.includes(q) || kat.includes(q) || baki.includes(q);
    });
  }, [selectedPermohonan, searchModalItem]);

  const handleOpenVerification = (permohonan, action) => {
    setVerifyingPermohonan(permohonan);
    setActionType(action);
    setCatatanVerifikasi('');
    setIsOpenVerificationModal(true);
  };

  const handleSubmitVerification = (e) => {
    e.preventDefault();
    if (!verifyingPermohonan) return;

    if (actionType === 'ditolak' && !catatanVerifikasi.trim()) {
      toast.warning('Silakan sertakan alasan penolakan permohonan!');
      return;
    }

    setIsOpenVerificationModal(false);
    setShowPinModalVerification(true);
  };

  const executeVerification = async () => {
    setIsSubmitting(true);
    setShowPinModalVerification(false);
    try {
      const res = await http.post(
        `permohonan-brankas/${verifyingPermohonan.id}/verifikasi`,
        { action: actionType, catatan_verifikasi: catatanVerifikasi },
        { headers: { Authorization: getAuthorizationHeader() } }
      );

      if (res.data.status) {
        toast.success(actionType === 'disetujui' ? 'Permohonan disetujui! Barang resmi masuk ke Brankas Pusat.' : 'Permohonan berhasil ditolak.');
        fetchPermohonanList();
        window.dispatchEvent(new Event('refresh-pending-verification'));
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || 'Gagal memproses verifikasi');
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case 'disetujui':
        return (
          <span className="px-2.5 py-1 bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700 rounded-lg text-xs font-bold flex items-center gap-1 w-fit">
            <IconCheck size={14} /> Disetujui
          </span>
        );
      case 'ditolak':
        return (
          <span className="px-2.5 py-1 bg-rose-100 dark:bg-rose-900/40 text-rose-800 dark:text-rose-300 border border-rose-300 dark:border-rose-700 rounded-lg text-xs font-bold flex items-center gap-1 w-fit">
            <IconX size={14} /> Ditolak
          </span>
        );
      case 'dibatalkan':
        return (
          <span className="px-2.5 py-1 bg-slate-100 dark:bg-slate-700 text-slate-700 dark:text-slate-300 border border-slate-300 dark:border-slate-600 rounded-lg text-xs font-bold flex items-center gap-1 w-fit">
            <IconX size={14} /> Dibatalkan
          </span>
        );
      default:
        return (
          <span className="px-2.5 py-1 bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-300 border border-amber-300 dark:border-amber-700 rounded-lg text-xs font-bold flex items-center gap-1 animate-pulse w-fit">
            <IconAlertCircle size={14} /> Menunggu Verifikator
          </span>
        );
    }
  };

  return (
    <Layouts 
    //title="Persetujuan Permohonan Pindah Brankas Pusat"
    >
      <div className="p-4 sm:p-6 w-full space-y-6 min-h-[75vh]">

        {/* Filter Controls */}
        <div className="bg-white dark:bg-slate-800 p-4 rounded-md border border-slate-200 dark:border-slate-700 shadow-sm flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 w-full md:w-auto flex-wrap">
            <select
              value={statusFilter}
              onChange={(e) => { setStatusFilter(e.target.value); setPage(1); }}
              className="px-3 py-2 text-xs border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500 h-[34px] flex-shrink-0"
            >
              <option value="">-- Semua Status --</option>
              <option value="pending">Menunggu Verifikasi</option>
              <option value="disetujui">Disetujui</option>
              <option value="ditolak">Ditolak</option>
              <option value="dibatalkan">Dibatalkan</option>
            </select>

            {/* Cabang Filter */}
            <select
              value={selectedCabang}
              onChange={(e) => { setSelectedCabang(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500 text-xs h-[34px] flex-shrink-0"
            >
              <option value="">-- Semua Cabang --</option>
              {cabangList.map(c => (
                <option key={c.id} value={c.id}>{c.nama_cabang}</option>
              ))}
            </select>

            {/* Operator Filter */}
            <select
              value={selectedUser}
              onChange={(e) => { setSelectedUser(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500 text-xs h-[34px] flex-shrink-0"
            >
              <option value="">-- Semua Operator --</option>
              {userList.map(u => (
                <option key={u.id} value={u.id}>{u.name}</option>
              ))}
            </select>

            {/* Date Range Dropdown */}
            <div className="dropdown dropdown-bottom flex-shrink-0">
              <div
                tabIndex={0}
                className="px-3 py-2 border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 cursor-pointer hover:border-amber-400 transition-all duration-200 flex items-center gap-2 text-xs h-[34px]"
              >
                <IconCalendarTime size={16} className="text-slate-400" />
                <span>
                  {startDate && endDate ? (awal === akhir ? awal : `${awal} - ${akhir}`) : 'Semua Tanggal'}
                </span>
              </div>
              <div tabIndex={0} className="dropdown-content menu p-2 shadow-xl bg-white dark:bg-slate-800 rounded-xl border border-slate-100 dark:border-slate-700 z-50 mt-1 right-0 sm:right-auto">
                <DateRange ranges={[selectionRange]} onChange={handleSelectDate} />
              </div>
            </div>

            <button
              onClick={() => { setStartDate(null); setEndDate(null); setStatusFilter(''); setSearch(''); setSelectedUser(''); setSelectedCabang(''); setPage(1); }}
              className="p-1.5 text-rose-500 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-lg transition-colors tooltip"
              data-tip="Reset Filter"
            >
              <IconReload size={18} />
            </button>
          </div>

          <div className="relative w-full md:w-64 flex-shrink-0">
            <IconSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              placeholder="Cari No. Request..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
              className="w-full pl-9 pr-3 py-2 text-xs border border-slate-300 dark:border-slate-600 rounded-lg bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 outline-none focus:ring-2 focus:ring-amber-500 h-[34px]"
            />
          </div>
        </div>

        {/* Table */}
        <div className="bg-white dark:bg-slate-800 rounded-md border border-slate-200 dark:border-slate-700 shadow-sm overflow-x-auto">
          {loading ? (
            <div className="py-16 flex flex-col items-center justify-center gap-3">
              <span className="loading loading-spinner loading-lg text-amber-500"></span>
              <p className="text-slate-400 text-xs animate-pulse">Memuat data permohonan...</p>
            </div>
          ) : permohonans.length === 0 ? (
            <div className="py-16 flex flex-col items-center justify-center text-slate-400 text-xs gap-3">
              <div className="p-4 bg-slate-50 dark:bg-slate-700/50 rounded-full animate-bounce">
                <IconInbox size={32} className="text-slate-300 dark:text-slate-500" stroke={1.5} />
              </div>
              <span>Tidak ada data permohonan ditemukan.</span>
            </div>
          ) : (
            <table className="w-full text-xs text-left text-slate-600 dark:text-slate-300">
              <thead className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/30 dark:via-amber-800/20 dark:to-amber-900/30 text-amber-800 dark:text-amber-300 border-b border-amber-200/70 dark:border-amber-800/40 text-[11px] font-bold tracking-wider uppercase">
                <tr>
                  <th className="p-3.5">No.</th>
                  <th className="p-3.5">No. Request</th>
                  <th className="p-3.5">Tgl Request</th>
                  <th className="p-3.5">Tgl Terima</th>
                  <th className="p-3.5">Brankas Asal (Toko)</th>
                  <th className="p-3.5">Pemohon</th>
                  <th className="p-3.5 text-center">Total Barang</th>
                  <th className="p-3.5">Status</th>
                  <th className="p-3.5 text-center">Aksi Verifikasi</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                {permohonans.map((p, index) => (
                  <tr
                    key={p.id}
                    onClick={() => handleOpenDetail(p.id)}
                    className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors cursor-pointer"
                  >
                    <td className="p-3.5 text-slate-500 font-medium">{(page - 1) * 10 + index + 1}.</td>
                    <td className="p-3.5 font-mono font-bold text-slate-800 dark:text-slate-100">{p.no_permohonan}</td>
                    <td className="p-3.5 text-slate-500">{new Date(p.tanggal || p.created_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</td>
                    <td className="p-3.5 text-slate-500">
                      {p.status !== 'pending' && p.updated_at 
                        ? new Date(p.updated_at).toLocaleDateString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) 
                        : '-'}
                    </td>
                    <td className="p-3.5 font-semibold text-slate-800 dark:text-slate-200">{p.cabang_asal?.nama_cabang ? p.cabang_asal.nama_cabang.replace(/Etalase/gi, 'Brankas') : ''}</td>
                    <td className="p-3.5 text-slate-700 dark:text-slate-300">{p.user_pemohon?.name}</td>
                    <td className="p-3.5 text-center">
                      <span className="font-bold text-slate-900 dark:text-slate-100">{p.total_pcs} PCS ({parseFloat(p.total_berat).toFixed(3)} gr)</span>
                    </td>
                    <td className="p-3.5">{renderStatusBadge(p.status)}</td>
                    <td className="p-3.5 text-center" onClick={(e) => e.stopPropagation()}>
                      <div className="flex items-center justify-center gap-1.5">
                        <button
                          onClick={() => handleOpenDetail(p.id)}
                          className="p-1.5 text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/30 rounded-lg transition-all"
                          title="Lihat Detail Item"
                        >
                          <IconEye size={16} />
                        </button>
                        <button 
                          onClick={() => handleOpenImageModal(p)}
                          className="p-1.5 bg-amber-50 dark:bg-slate-700 hover:bg-amber-100 dark:hover:bg-slate-600 text-amber-600 dark:text-amber-400 rounded-lg transition-colors"
                          title="Lihat Detail Item & Gambar"
                        >
                          <IconPhoto size={16} />
                        </button>

                        {p.status === 'pending' && (
                          <>
                            <button
                              onClick={() => handleOpenVerification(p, 'disetujui')}
                              className="px-2.5 py-1 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-[11px] rounded-lg shadow transition-all flex items-center gap-1"
                            >
                              <IconCheck size={14} />
                              <span>Setujui</span>
                            </button>
                            <button
                              onClick={() => handleOpenVerification(p, 'ditolak')}
                              className="px-2.5 py-1 bg-rose-600 hover:bg-rose-700 text-white font-semibold text-[11px] rounded-lg shadow transition-all flex items-center gap-1"
                            >
                              <IconX size={14} />
                              <span>Tolak</span>
                            </button>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {!loading && permohonans.length > 0 && (
            <div className="flex flex-col sm:flex-row justify-between items-center gap-3 p-3.5 border-t border-slate-100 dark:border-slate-700 bg-slate-50/50 dark:bg-slate-800/50">
              <span className="text-xs text-slate-500 dark:text-slate-400">
                Menampilkan <span className="font-semibold text-slate-700 dark:text-slate-200">{permohonans.length}</span> dari <span className="font-semibold text-slate-700 dark:text-slate-200">{totalPermohonan}</span> permohonan
              </span>
              <div className="flex items-center gap-2.5">
                <span className="text-xs font-medium text-slate-500 dark:text-slate-400 flex items-center gap-1.5">
                  Halaman
                  <input
                    type="text"
                    value={pageInput}
                    onChange={(e) => setPageInput(e.target.value)}
                    onBlur={jumpToPage}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        jumpToPage();
                        e.target.blur();
                      }
                    }}
                    className="w-12 h-7 text-center border border-slate-200 dark:border-slate-600 rounded-md bg-white dark:bg-slate-800 text-amber-700 dark:text-amber-400 font-bold focus:border-amber-400 focus:ring-1 focus:ring-amber-200 outline-none transition-all"
                  />
                  dari <span className="font-bold text-amber-700 dark:text-amber-400">{lastPage}</span>
                </span>
                <div className="flex items-center gap-1">
                  <button
                    onClick={() => setPage((prev) => Math.max(1, prev - 1))}
                    disabled={page <= 1}
                    title="previous"
                    type="button"
                    className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    <IconChevronLeft size={16} />
                  </button>
                  <button
                    onClick={() => setPage((prev) => Math.min(lastPage, prev + 1))}
                    disabled={page >= lastPage}
                    title="next"
                    type="button"
                    className="inline-flex items-center justify-center w-8 h-8 border border-slate-200 dark:border-slate-600 rounded-lg shadow-sm hover:bg-amber-50 dark:hover:bg-slate-800 hover:border-amber-300 dark:hover:border-amber-600 hover:text-amber-600 dark:hover:text-amber-400 disabled:opacity-40 disabled:cursor-not-allowed transition-all duration-200"
                  >
                    <IconChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Modal Verification Action */}
        {isOpenVerificationModal && verifyingPermohonan && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-lg rounded-2xl p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700">
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3">
                <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100 flex items-center gap-2">
                  {actionType === 'disetujui' ? <IconCheck className="text-emerald-500" size={18} /> : <IconX className="text-rose-500" size={18} />}
                  <span>{actionType === 'disetujui' ? 'Konfirmasi Persetujuan Permohonan' : 'Konfirmasi Penolakan Permohonan'}</span>
                </h3>
                <button
                  type="button"
                  onClick={() => setIsOpenVerificationModal(false)}
                  className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-700/60 transition-colors cursor-pointer"
                >
                  <IconX size={18} />
                </button>
              </div>

              <div className="bg-slate-50 dark:bg-slate-700/40 p-3.5 rounded-xl border border-slate-200 dark:border-slate-700 text-xs space-y-1.5 text-slate-700 dark:text-slate-300">
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">No. Request:</strong>{' '}
                  <span className="font-mono font-bold text-amber-600 dark:text-amber-400">{verifyingPermohonan.no_permohonan}</span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Asal Toko:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {verifyingPermohonan.cabang_asal?.nama_cabang ? verifyingPermohonan.cabang_asal.nama_cabang.replace(/Etalase/gi, 'Brankas') : ''}
                  </span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Pemohon:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">{verifyingPermohonan.user_pemohon?.name}</span>
                </p>
                <p>
                  <strong className="text-slate-900 dark:text-slate-100">Total Barang:</strong>{' '}
                  <span className="text-slate-700 dark:text-slate-200">
                    {verifyingPermohonan.total_pcs} Pcs ({parseFloat(verifyingPermohonan.total_berat).toFixed(3)} gr)
                  </span>
                </p>
              </div>

              <form onSubmit={handleSubmitVerification} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold text-slate-600 dark:text-slate-300 mb-1.5">
                    Catatan Verifikasi {actionType === 'ditolak' && <span className="text-rose-500">* (Wajib diisi jika menolak)</span>}
                  </label>
                  <textarea
                    rows={3}
                    placeholder={actionType === 'disetujui' ? 'Catatan opsional...' : 'Jelaskan alasan penolakan...'}
                    value={catatanVerifikasi}
                    onChange={(e) => setCatatanVerifikasi(e.target.value)}
                    required={actionType === 'ditolak'}
                    className="w-full p-2.5 text-xs border border-slate-300 dark:border-slate-600 rounded-xl bg-white dark:bg-slate-700 text-slate-800 dark:text-slate-100 placeholder:text-slate-400 dark:placeholder:text-slate-500 outline-none focus:ring-2 focus:ring-amber-500"
                  />
                </div>

                <div className="flex justify-end gap-2 pt-2 border-t border-slate-100 dark:border-slate-700">
                  <button
                    type="button"
                    onClick={() => setIsOpenVerificationModal(false)}
                    className="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all border border-slate-200 dark:border-slate-700 cursor-pointer"
                  >
                    Batal
                  </button>
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`px-5 py-2 text-xs font-bold text-white rounded-xl shadow-lg transition-all cursor-pointer ${
                      actionType === 'disetujui'
                        ? 'bg-emerald-600 hover:bg-emerald-700 shadow-emerald-600/20'
                        : 'bg-rose-600 hover:bg-rose-700 shadow-rose-600/20'
                    }`}
                  >
                    {isSubmitting ? 'Memproses...' : actionType === 'disetujui' ? 'Setujui & Masukkan ke Brankas Pusat' : 'Tolak Permohonan'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Detail Items Modal (5 Tabs) */}
        {isOpenDetailModal && selectedPermohonan && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setIsOpenDetailModal(false)}>
            <div
              className="bg-white dark:bg-slate-800 w-full max-w-4xl lg:max-w-5xl rounded-md p-5 md:p-6 shadow-2xl border border-slate-200 dark:border-slate-700 max-h-[92vh] flex flex-col space-y-4"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3 flex-shrink-0">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-bold text-sm md:text-base text-slate-800 dark:text-slate-100">
                      Detail Permohonan: <span className="font-mono text-amber-600">{selectedPermohonan.no_permohonan}</span>
                    </h3>
                    {selectedPermohonan.status === 'pending' ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 rounded-md border border-amber-300 dark:border-amber-700 text-[11px] font-bold">Pending</span>
                    ) : selectedPermohonan.status === 'disetujui' ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300 rounded-md border border-emerald-300 dark:border-emerald-700 text-[11px] font-bold">✓ Disetujui</span>
                    ) : selectedPermohonan.status === 'dibatalkan' ? (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-md border border-slate-300 text-[11px] font-bold">Dibatalkan</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 px-2 py-0.5 bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300 rounded-md border border-rose-300 dark:border-rose-700 text-[11px] font-bold">✕ Ditolak</span>
                    )}
                  </div>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 text-[11px] text-slate-500 mt-1">
                    <span><strong className="text-slate-600 dark:text-slate-400">Request:</strong> {new Date(selectedPermohonan.created_at).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                    {selectedPermohonan.status !== 'pending' && selectedPermohonan.updated_at && (
                      <span><strong className="text-slate-600 dark:text-slate-400">Verifikasi:</strong> {new Date(selectedPermohonan.updated_at).toLocaleString('id-ID', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</span>
                    )}
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setIsOpenDetailModal(false)}
                  className="p-1.5 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-lg transition-colors cursor-pointer"
                >
                  <IconX size={20} />
                </button>
              </div>

              {/* Top Quick Info Strip */}
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-xs bg-slate-50 dark:bg-slate-700/40 p-3 rounded-xl flex-shrink-0">
                <div>
                  <span className="text-slate-400 block text-[10px]">Toko Asal (Brankas)</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {selectedPermohonan.cabang_asal?.nama_cabang ? selectedPermohonan.cabang_asal.nama_cabang.replace(/Etalase/gi, 'Brankas') : '-'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Operator Pemohon</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {selectedPermohonan.user_pemohon?.name || selectedPermohonan.userPemohon?.name || '-'}
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Total Item & Berat</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 truncate block">
                    {selectedPermohonan.total_pcs || (selectedPermohonan.items ? selectedPermohonan.items.length : 0)} PCS
                    <span className="text-amber-600 dark:text-amber-400 font-semibold ml-1">
                      ({parseFloat(selectedPermohonan.total_berat || (selectedPermohonan.items ? selectedPermohonan.items.reduce((acc, it) => acc + parseFloat(it.berat || 0), 0) : 0)).toFixed(3)} gr)
                    </span>
                  </span>
                </div>
                <div>
                  <span className="text-slate-400 block text-[10px]">Verifikator</span>
                  <span className="font-bold text-emerald-600 dark:text-emerald-400 truncate block">
                    {selectedPermohonan.user_verifikator?.name || selectedPermohonan.userVerifikator?.name || (selectedPermohonan.status === 'pending' ? 'Menunggu...' : selectedPermohonan.status === 'dibatalkan' ? 'Dibatalkan' : '-')}
                  </span>
                </div>
              </div>

              {/* 5 Tab Navigation Bar */}
              <div className="flex border-b border-slate-200 dark:border-slate-700 gap-1 overflow-x-auto scrollbar-none flex-shrink-0">
                <button
                  type="button"
                  onClick={() => setModalTab('ringkasan')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'ringkasan'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconChartPie size={16} />
                  <span>Ringkasan Item</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('list')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'list'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconListDetails size={16} />
                  <span>List Item ({selectedPermohonan.items?.length || 0})</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('operator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'operator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconUser size={16} />
                  <span>Operator Pemohon</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('verifikator')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'verifikator'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconCircleCheck size={16} />
                  <span>Verifikator</span>
                </button>
                <button
                  type="button"
                  onClick={() => setModalTab('galeri')}
                  className={`px-3 py-2 text-xs font-bold flex items-center gap-1.5 border-b-2 transition-all whitespace-nowrap cursor-pointer ${
                    modalTab === 'galeri'
                      ? 'border-amber-500 text-amber-600 dark:text-amber-400 bg-amber-50/50 dark:bg-amber-900/10'
                      : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                  }`}
                >
                  <IconPhoto size={16} />
                  <span>Galeri List Item</span>
                </button>
              </div>

              {/* Scrollable Tab Content */}
              <div className="flex-1 overflow-y-auto pr-1">
                {/* 1. Tab Ringkasan Item */}
                {modalTab === 'ringkasan' && (() => {
                  const itemsList = selectedPermohonan.items || [];
                  const totalPcsVal = selectedPermohonan.total_pcs || itemsList.length;
                  const totalBeratVal = parseFloat(selectedPermohonan.total_berat || itemsList.reduce((acc, it) => acc + parseFloat(it.berat || it.item?.berat || 0), 0));
                  const avgBeratVal = itemsList.length > 0 ? (totalBeratVal / itemsList.length) : (totalPcsVal > 0 ? totalBeratVal / totalPcsVal : 0);
                  const validModalItems = itemsList.filter(it => Number(it.harga_modal || it.item?.harga_modal || 0) > 0);
                  const avgModalVal = validModalItems.length > 0
                    ? Math.round(validModalItems.reduce((acc, it) => acc + Number(it.harga_modal || it.item?.harga_modal || 0), 0) / validModalItems.length)
                    : 0;
                  const maxBeratVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => parseFloat(it.berat || it.item?.berat || 0) || 0)) : 0;
                  const maxModalVal = itemsList.length > 0 ? Math.max(...itemsList.map(it => Number(it.harga_modal || it.item?.harga_modal || 0) || 0)) : 0;

                  return (
                    <div className="space-y-4">
                      {/* Ringkasan Cards (7 Cards) */}
                      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 sm:gap-3">
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Barang</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {totalPcsVal} <span className="text-xs font-semibold text-slate-500">Pcs</span>
                          </div>
                        </div>
                        <div className="bg-amber-50/60 dark:bg-amber-950/20 border border-amber-200/70 dark:border-amber-900/40 rounded-xl p-3">
                          <span className="text-amber-700 dark:text-amber-400 text-[10px] font-bold uppercase tracking-wider block">Total Berat</span>
                          <div className="text-lg font-extrabold text-amber-600 dark:text-amber-400 mt-0.5 font-mono">
                            {totalBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Total Kategori</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5">
                            {Object.keys(detailSummary).length} <span className="text-xs font-semibold text-slate-500">Kategori</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Berat</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {avgBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Rata-rata Modal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {avgModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Berat Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            {maxBeratVal.toFixed(3)} <span className="text-xs font-semibold text-slate-500 font-sans">gr</span>
                          </div>
                        </div>
                        <div className="bg-slate-50 dark:bg-slate-700/30 border border-slate-200 dark:border-slate-700 rounded-xl p-3">
                          <span className="text-slate-500 text-[10px] font-bold uppercase tracking-wider block">Modal Maksimal</span>
                          <div className="text-lg font-extrabold text-slate-800 dark:text-slate-100 mt-0.5 font-mono">
                            Rp {maxModalVal.toLocaleString('id-ID')}
                          </div>
                        </div>
                      </div>

                    {/* Breakdown Kategori & Karat */}
                    {Object.keys(detailSummary).length > 0 && (
                      <div className="space-y-3 p-3.5 bg-amber-50/50 dark:bg-amber-900/10 border border-amber-200/50 dark:border-amber-900/30 rounded-xl">
                        <div className="flex items-center justify-between">
                          <h4 className="text-[11px] font-bold text-amber-800 dark:text-amber-400 uppercase tracking-wider flex items-center gap-1.5">
                            <IconChartPie size={16} />
                            <span>Breakdown Per Kategori & Karat</span>
                          </h4>
                          <span className="text-[10px] text-amber-700 dark:text-amber-400 font-semibold">
                            {Object.keys(detailSummary).length} Kategori
                          </span>
                        </div>
                        <div className="space-y-2">
                          {Object.values(detailSummary).map((cat, idx) => (
                            <div key={idx} className="bg-white dark:bg-slate-800 p-3 rounded-xl border border-amber-200/60 dark:border-slate-700 shadow-sm">
                              <div className="flex justify-between items-center mb-2 pb-2 border-b border-slate-100 dark:border-slate-700">
                                <span className="font-bold text-slate-800 dark:text-slate-100 text-sm">{cat.name}</span>
                                <span className="font-bold text-amber-600 dark:text-amber-400 text-xs bg-amber-50 dark:bg-amber-900/30 border border-amber-200 dark:border-amber-800 px-2.5 py-0.5 rounded-md">
                                  {cat.pcs} Pcs ({cat.berat.toFixed(3)} gr)
                                </span>
                              </div>
                              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                                {Object.entries(cat.byKarat).map(([karat, val], i) => (
                                  <div key={i} className="flex items-center justify-between bg-slate-50 dark:bg-slate-700/40 px-2.5 py-1.5 rounded-lg text-xs border border-slate-100 dark:border-slate-700">
                                    <span className="font-semibold text-slate-500 dark:text-slate-400">{karat} Karat</span>
                                    <span className="font-bold text-slate-800 dark:text-slate-100">{val.pcs} Pcs / {val.berat.toFixed(3)}g</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}

                    {/* Catatan Area */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 pt-1">
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">Catatan Pemohon</span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium">
                          {selectedPermohonan.catatan_pemohon || <span className="italic text-slate-400">Tidak ada catatan</span>}
                        </p>
                      </div>
                      <div className="p-3 bg-slate-50 dark:bg-slate-700/30 rounded-xl border border-slate-200 dark:border-slate-700 space-y-1">
                        <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block">
                          {selectedPermohonan.status === 'dibatalkan' ? 'Alasan Pembatalan' : 'Catatan Verifikator'}
                        </span>
                        <p className="text-xs text-slate-700 dark:text-slate-300 font-medium">
                          {((selectedPermohonan.catatan_verifikasi || selectedPermohonan.catatan_verifikator || selectedPermohonan.alasan_batal)
                            ? (selectedPermohonan.catatan_verifikasi || selectedPermohonan.catatan_verifikator || selectedPermohonan.alasan_batal).replace(/^\[BATAL\]\s*/i, '')
                            : null) || (
                            <span className="italic text-slate-400">
                              {selectedPermohonan.status === 'pending' ? 'Menunggu verifikasi...' : 'Tidak ada catatan'}
                            </span>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })()}

                {/* 2. Tab List Item (Tabel) */}
                {modalTab === 'list' && (
                  <div className="space-y-3">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="relative flex-1 max-w-xs">
                        <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                        <input
                          type="text"
                          placeholder="Cari kode, jenis, baki..."
                          value={searchModalItem}
                          onChange={(e) => setSearchModalItem(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                        />
                      </div>
                      <span className="text-[11px] text-slate-500 font-medium">
                        Menampilkan {filteredModalItems.length} dari {selectedPermohonan.items?.length || 0} item
                      </span>
                    </div>

                    <div className="border border-slate-200 dark:border-slate-700 rounded-xl overflow-x-auto max-h-80">
                      <table className="w-full text-xs text-left text-slate-600 dark:text-slate-300">
                        <thead className="bg-gradient-to-r from-amber-50 via-amber-100/80 to-amber-50 dark:from-amber-900/40 dark:via-amber-800/30 dark:to-amber-900/40 text-[11px] text-amber-800 dark:text-amber-300 uppercase border-b border-amber-200/70 dark:border-amber-800/40 sticky top-0 z-10 font-bold tracking-wider">
                          <tr>
                            <th className="p-2.5 w-10 text-center font-bold">No</th>
                            <th className="p-2.5 font-bold">Kode Barang</th>
                            <th className="p-2.5 font-bold">Nama Barang</th>
                            <th className="p-2.5 text-center font-bold">Baki / Rak</th>
                            <th className="p-2.5 text-right font-bold">Berat (gr)</th>
                            <th className="p-2.5 text-center font-bold">Karat</th>
                            <th className="p-2.5 text-center font-bold">Status</th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-slate-100 dark:divide-slate-700/50">
                          {filteredModalItems.length === 0 ? (
                            <tr>
                              <td colSpan={7} className="text-center py-6 text-slate-400">
                                Tidak ada item yang sesuai dengan pencarian
                              </td>
                            </tr>
                          ) : (
                            filteredModalItems.map((it, idx) => (
                              <tr key={it.id} className="hover:bg-slate-50 dark:hover:bg-slate-700/30 transition-colors">
                                <td className="p-2.5 text-slate-500 font-medium text-center">{idx + 1}.</td>
                                <td className="p-2.5 font-mono font-bold text-amber-600 dark:text-amber-400">{it.kode_item}</td>
                                <td className="p-2.5">
                                  <span className="text-slate-600 dark:text-slate-400">{it.jenis_kategori?.nama_jenis || '-'}</span>
                                </td>
                                <td className="p-2.5 text-center font-medium">{it.nomor_rak || '-'}</td>
                                <td className="p-2.5 text-right font-bold text-amber-600 dark:text-amber-400">{parseFloat(it.berat).toFixed(3)} gr</td>
                                <td className="p-2.5 text-center font-semibold">{it.karat} K</td>
                                <td className="p-2.5 text-center">
                                  <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${
                                    it.pivot?.status_item === 'disetujui' || selectedPermohonan.status === 'disetujui'
                                      ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/60 dark:text-emerald-300'
                                      : it.pivot?.status_item === 'ditolak' || selectedPermohonan.status === 'ditolak'
                                      ? 'bg-rose-100 text-rose-700 dark:bg-rose-950/60 dark:text-rose-300'
                                      : it.pivot?.status_item === 'dibatalkan' || selectedPermohonan.status === 'dibatalkan'
                                      ? 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'
                                      : 'bg-amber-100 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300'
                                  }`}>
                                    {it.pivot?.status_item || selectedPermohonan.status}
                                  </span>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                        {filteredModalItems.length > 0 && (
                          <tfoot className="bg-slate-50 dark:bg-slate-700/50 font-bold border-t border-slate-200 dark:border-slate-700 sticky bottom-0">
                            <tr>
                              <td colSpan={4} className="p-2.5 text-right text-slate-600 dark:text-slate-300">
                                Total ({filteredModalItems.length} item):
                              </td>
                              <td className="p-2.5 text-right text-amber-600 dark:text-amber-400 font-mono">
                                {filteredModalItems.reduce((acc, it) => acc + parseFloat(it.berat || 0), 0).toFixed(3)} gr
                              </td>
                              <td colSpan={2}></td>
                            </tr>
                          </tfoot>
                        )}
                      </table>
                    </div>
                  </div>
                )}

                {/* 3. Tab Operator Pemohon */}
                {modalTab === 'operator' && (() => {
                  const userPemohon = selectedPermohonan.user_pemohon || selectedPermohonan.userPemohon;
                  return (
                    <div className="space-y-4">
                      <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                          <div className="flex items-center gap-3.5">
                            <div className="w-12 h-12 rounded-2xl bg-amber-500/10 dark:bg-amber-400/20 text-amber-600 dark:text-amber-400 flex items-center justify-center font-bold text-lg border border-amber-200 dark:border-amber-700/50">
                              {userPemohon?.name ? userPemohon.name.charAt(0).toUpperCase() : <IconUser size={24} />}
                            </div>
                            <div>
                              <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                                {userPemohon?.name || 'Operator Rumah'}
                              </h4>
                              {userPemohon?.email && (
                                <p className="text-xs text-slate-500 dark:text-slate-400">
                                  {userPemohon.email}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                              {userPemohon?.roles?.map((r) => r.name.replace(/_/g, ' ').toUpperCase()).join(', ') || 'OPERATOR RUMAH'}
                            </span>
                            <span className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                              userPemohon?.is_active !== false && userPemohon?.is_active !== 0
                                ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border-emerald-200 dark:border-emerald-800'
                                : 'bg-slate-100 dark:bg-slate-800 text-slate-500 border-slate-200'
                            }`}>
                              {userPemohon?.is_active !== false && userPemohon?.is_active !== 0 ? '● Akun Aktif' : '○ Non-Aktif'}
                            </span>
                          </div>
                        </div>

                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Cabang / Brankas Asal</span>
                            <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                              <IconBuildingStore size={15} className="text-amber-500" />
                              <span>{selectedPermohonan.cabang_asal?.nama_cabang ? selectedPermohonan.cabang_asal.nama_cabang.replace(/Etalase/gi, 'Brankas') : (userPemohon?.cabang?.nama_cabang || '-')}</span>
                            </div>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Lokasi Toko</span>
                            <p className="font-semibold text-slate-700 dark:text-slate-300">
                              {selectedPermohonan.cabang_asal?.lokasi || userPemohon?.cabang?.lokasi || '-'}
                            </p>
                          </div>

                          <div className="space-y-1">
                            <span className="text-slate-400 text-[11px] block">Waktu Pengajuan Permohonan</span>
                            <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                              <IconClock size={15} className="text-slate-400" />
                              <span>{moment(selectedPermohonan.created_at).format('DD MMM YYYY, HH:mm')}</span>
                            </div>
                          </div>

                          <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                            <span className="text-slate-400 text-[11px] block">Catatan yang Dilampirkan Pemohon</span>
                            <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                              {selectedPermohonan.catatan_pemohon || <span className="italic text-slate-400">Tidak ada catatan khusus dari pemohon.</span>}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })()}

                {/* 4. Tab Verifikator */}
                {modalTab === 'verifikator' && (() => {
                  const userVerifikator = selectedPermohonan.user_verifikator || selectedPermohonan.userVerifikator;
                  return (
                    <div className="space-y-4">
                      {userVerifikator && selectedPermohonan.status !== 'dibatalkan' ? (
                        <div className="bg-slate-50 dark:bg-slate-700/30 p-5 rounded-2xl border border-slate-200 dark:border-slate-700">
                          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-4 border-b border-slate-200 dark:border-slate-600">
                            <div className="flex items-center gap-3.5">
                              <div className="w-12 h-12 rounded-2xl bg-emerald-500/10 dark:bg-emerald-400/20 text-emerald-600 dark:text-emerald-400 flex items-center justify-center font-bold text-lg border border-emerald-200 dark:border-emerald-700/50">
                                {userVerifikator.name ? userVerifikator.name.charAt(0).toUpperCase() : <IconCircleCheck size={24} />}
                              </div>
                              <div>
                                <h4 className="font-bold text-base text-slate-800 dark:text-slate-100">
                                  {userVerifikator.name}
                                </h4>
                                {userVerifikator?.email && (
                                  <p className="text-xs text-slate-500 dark:text-slate-400">
                                    {userVerifikator.email}
                                  </p>
                                )}
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <span className="px-2.5 py-1 text-[11px] font-bold rounded-lg bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                                {userVerifikator.roles?.map((r) => r.name.replace(/_/g, ' ').toUpperCase()).join(', ') || 'ADMIN PUSAT'}
                              </span>
                              <span className={`px-2.5 py-1 text-[11px] font-bold rounded-lg border ${
                                selectedPermohonan.status === 'disetujui'
                                  ? 'bg-emerald-100 text-emerald-700 border-emerald-300 dark:bg-emerald-950/60 dark:text-emerald-300 dark:border-emerald-700'
                                  : selectedPermohonan.status === 'ditolak'
                                  ? 'bg-rose-100 text-rose-700 border-rose-300 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-700'
                                  : 'bg-slate-100 text-slate-700 border-slate-300 dark:bg-slate-800 dark:text-slate-300'
                              }`}>
                                {selectedPermohonan.status === 'disetujui'
                                  ? '✓ Disetujui'
                                  : selectedPermohonan.status === 'ditolak'
                                  ? '✕ Ditolak'
                                  : selectedPermohonan.status === 'dibatalkan'
                                  ? 'Dibatalkan'
                                  : selectedPermohonan.status}
                              </span>
                            </div>
                          </div>

                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 pt-4 text-xs">
                            <div className="space-y-1">
                              <span className="text-slate-400 text-[11px] block">Unit / Cabang Verifikator</span>
                              <div className="flex items-center gap-1.5 font-bold text-slate-800 dark:text-slate-200">
                                <IconBuildingStore size={15} className="text-emerald-500" />
                                <span>{userVerifikator.cabang?.nama_cabang || 'Kantor Pusat'}</span>
                              </div>
                            </div>

                            <div className="space-y-1">
                              <span className="text-slate-400 text-[11px] block">Waktu Verifikasi Selesai</span>
                              <div className="flex items-center gap-1.5 font-semibold text-slate-700 dark:text-slate-300">
                                <IconClock size={15} className="text-emerald-500" />
                                <span>{moment(selectedPermohonan.updated_at).format('DD MMM YYYY, HH:mm:ss')}</span>
                              </div>
                            </div>

                            <div className="space-y-1">
                              <span className="text-slate-400 text-[11px] block">Status Akun</span>
                              <span className="font-semibold text-emerald-600 dark:text-emerald-400">
                                {userVerifikator.is_active !== false && userVerifikator.is_active !== 0 ? '● Aktif' : '○ Non-Aktif'}
                              </span>
                            </div>

                            <div className="space-y-1 sm:col-span-2 md:col-span-3 pt-2 border-t border-slate-200 dark:border-slate-600">
                              <span className="text-slate-400 text-[11px] block">Catatan / Keterangan Verifikator</span>
                              <div className="p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-slate-700 dark:text-slate-300 font-medium leading-relaxed">
                                {((selectedPermohonan.catatan_verifikasi || selectedPermohonan.catatan_verifikator || selectedPermohonan.alasan_batal)
                                  ? (selectedPermohonan.catatan_verifikasi || selectedPermohonan.catatan_verifikator || selectedPermohonan.alasan_batal).replace(/^\[BATAL\]\s*/i, '')
                                  : null) || (
                                  <span className="italic text-slate-400">Tidak ada catatan atau instruksi khusus dari verifikator.</span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : selectedPermohonan.status === 'dibatalkan' ? (
                        <div className="p-8 text-center bg-slate-50 dark:bg-slate-700/20 rounded-2xl border border-slate-200 dark:border-slate-700 space-y-3">
                          <div className="w-12 h-12 mx-auto rounded-full bg-slate-200 dark:bg-slate-700 text-slate-500 flex items-center justify-center">
                            <IconAlertTriangle size={24} />
                          </div>
                          <h4 className="font-bold text-sm text-slate-800 dark:text-slate-100">Permohonan Telah Dibatalkan</h4>
                          <p className="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
                            Permohonan ini telah dibatalkan sebelum diproses verifikasinya oleh Admin Pusat.
                          </p>
                          {(selectedPermohonan.catatan_verifikasi || selectedPermohonan.alasan_batal || selectedPermohonan.catatan_verifikator) && (
                            <div className="mt-3 p-3 bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 text-xs text-slate-700 dark:text-slate-300 max-w-md mx-auto text-left">
                              <strong className="text-slate-500 block mb-1">Alasan Pembatalan:</strong>
                              {(selectedPermohonan.catatan_verifikasi || selectedPermohonan.alasan_batal || selectedPermohonan.catatan_verifikator).replace(/^\[BATAL\]\s*/i, '')}
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="p-8 text-center bg-amber-50/50 dark:bg-amber-900/10 rounded-2xl border border-amber-200/60 dark:border-amber-900/30 space-y-3">
                          <div className="w-12 h-12 mx-auto rounded-full bg-amber-100 dark:bg-amber-900/40 text-amber-600 dark:text-amber-400 flex items-center justify-center">
                            <IconClock size={24} />
                          </div>
                          <h4 className="font-bold text-sm text-amber-800 dark:text-amber-300">Menunggu Verifikator</h4>
                          <p className="text-xs text-slate-600 dark:text-slate-400 max-w-md mx-auto">
                            Permohonan ini berstatus <strong className="text-amber-700 dark:text-amber-400">Pending</strong> dan sedang dalam antrean pemeriksaan oleh tim Admin Pusat / Owner. Informasi detail akun verifikator akan muncul secara otomatis setelah dokumen disetujui atau ditolak.
                          </p>
                        </div>
                      )}
                    </div>
                  );
                })()}

                {/* 5. Tab Galeri List Item */}
                {modalTab === 'galeri' && (
                  <div className="space-y-4">
                    <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                      <div className="relative flex-1 max-w-xs">
                        <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={15} />
                        <input
                          type="text"
                          placeholder="Cari kode, jenis, baki..."
                          value={searchModalItem}
                          onChange={(e) => setSearchModalItem(e.target.value)}
                          className="w-full pl-8 pr-3 py-1.5 text-xs bg-slate-50 dark:bg-slate-700/50 border border-slate-200 dark:border-slate-600 rounded-lg outline-none focus:border-amber-400 focus:ring-1 focus:ring-amber-200"
                        />
                      </div>
                      <span className="text-[11px] text-slate-500 font-medium">
                        Menampilkan {filteredModalItems.length} foto item
                      </span>
                    </div>

                    {filteredModalItems.length === 0 ? (
                      <div className="py-12 text-center text-slate-400">
                        <IconInbox size={36} className="mx-auto mb-2 opacity-50" />
                        <p className="text-xs">Tidak ada item yang sesuai dengan pencarian</p>
                      </div>
                    ) : (
                      <PhotoProvider>
                        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                          {filteredModalItems.map((item) => {
                            const imgUrl = resolveItemImageUrl(item);
                            return (
                              <div
                                key={item.id}
                                className="bg-white dark:bg-slate-800 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:shadow-md transition-shadow group flex flex-col"
                              >
                                <div className="aspect-square bg-slate-100 dark:bg-slate-700/50 relative flex items-center justify-center overflow-hidden">
                                  {imgUrl ? (
                                    <PhotoView src={imgUrl}>
                                      <img
                                        src={imgUrl}
                                        alt={item.kode_item}
                                        className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 cursor-pointer"
                                        onError={(e) => {
                                          e.target.style.display = 'none';
                                        }}
                                      />
                                    </PhotoView>
                                  ) : (
                                    <div className="flex flex-col items-center justify-center text-slate-400 p-2 text-center">
                                      <IconPhoto size={28} className="opacity-40 mb-1" />
                                      <span className="text-[10px]">Belum Ada Gambar</span>
                                    </div>
                                  )}
                                  <div className="absolute top-2 left-2 bg-slate-900/80 backdrop-blur-sm text-amber-400 text-[10px] font-mono font-bold px-2 py-0.5 rounded shadow">
                                    {item.kode_item}
                                  </div>
                                  <div className="absolute top-2 right-2 bg-amber-500 text-white text-[10px] font-bold px-1.5 py-0.5 rounded shadow">
                                    {item.karat} K
                                  </div>
                                </div>

                                <div className="p-2.5 text-xs flex-1 flex flex-col justify-between space-y-2">
                                  <div>
                                    <p className="font-bold text-slate-800 dark:text-slate-100 text-[11px] truncate" title={`${item.jenis_kategori?.kategori?.nama_kategori || ''} - ${item.jenis_kategori?.nama_jenis || ''}`}>
                                      {item.jenis_kategori?.kategori?.nama_kategori || '-'} - {item.jenis_kategori?.nama_jenis || '-'}
                                    </p>
                                    <p className="text-[10px] text-slate-500 dark:text-slate-400">
                                      Baki: <span className="font-semibold text-slate-700 dark:text-slate-300">{item.nomor_rak || '-'}</span>
                                    </p>
                                  </div>
                                  <div className="flex items-center justify-between pt-1.5 border-t border-slate-100 dark:border-slate-700">
                                    <span className="text-[10px] text-slate-400">Berat</span>
                                    <span className="font-bold text-amber-600 dark:text-amber-400 text-xs">
                                      {parseFloat(item.berat || 0).toFixed(3)} gr
                                    </span>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      </PhotoProvider>
                    )}
                  </div>
                )}
              </div>

              {/* Modal Footer */}
              <div className="flex flex-col-reverse sm:flex-row justify-between items-center gap-2 pt-3 border-t border-slate-100 dark:border-slate-700 flex-shrink-0">
                {selectedPermohonan.status === 'pending' ? (
                  <div className="flex items-center gap-2 w-full sm:w-auto">
                    <button
                      type="button"
                      onClick={() => {
                        setIsOpenDetailModal(false);
                        handleOpenVerification(selectedPermohonan, 'disetujui');
                      }}
                      className="flex-1 sm:flex-initial px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-xs rounded-xl shadow-lg shadow-emerald-600/20 transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                    >
                      <IconCheck size={16} />
                      <span>Setujui Permohonan</span>
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setIsOpenDetailModal(false);
                        handleOpenVerification(selectedPermohonan, 'ditolak');
                      }}
                      className="flex-1 sm:flex-initial px-4 py-2 bg-rose-600 hover:bg-rose-700 text-white font-bold text-xs rounded-xl shadow-lg shadow-rose-600/20 transition-all flex items-center justify-center gap-1.5 cursor-pointer"
                    >
                      <IconX size={16} />
                      <span>Tolak Permohonan</span>
                    </button>
                  </div>
                ) : <div />}
                <button
                  type="button"
                  onClick={() => setIsOpenDetailModal(false)}
                  className="w-full sm:w-auto px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 rounded-xl transition-all cursor-pointer"
                >
                  Tutup
                </button>
              </div>
            </div>
          </div>
        )}
        {/* Paginated Detail Image Modal */}
        {isOpenImageModal && selectedImagePermohonan && (
          <div className="fixed inset-0 z-[999] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
            <div className="bg-white dark:bg-slate-800 w-full max-w-5xl rounded-2xl p-6 shadow-2xl space-y-4 border border-slate-200 dark:border-slate-700 h-[85vh] flex flex-col">
              <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700 pb-3 flex-shrink-0">
                <div>
                  <h3 className="font-bold text-sm text-slate-800 dark:text-slate-100">
                    Detail Gambar Item: <span className="font-mono text-amber-600">{selectedImagePermohonan.no_permohonan}</span>
                  </h3>
                  <p className="text-xs text-slate-500 mt-1">
                    Hanya menampilkan barang-barang untuk permohonan ini.
                    {imageItems.length > 0 && (
                      <span className="ml-2 block sm:inline mt-2 sm:mt-0">
                        Total Item: <strong className="text-slate-700 dark:text-slate-300">{selectedImagePermohonan.total_pcs} PCS</strong> |{' '}
                        Total Berat: <strong className="text-slate-700 dark:text-slate-300">{parseFloat(selectedImagePermohonan.total_berat).toFixed(3)} gr</strong> |{' '}
                        Total Modal: <strong className="text-slate-700 dark:text-slate-300">{new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(totalModalPermohonan)}</strong>
                      </span>
                    )}
                  </p>
                </div>
                <button onClick={() => setIsOpenImageModal(false)} className="text-slate-400 hover:text-slate-600">
                  <IconX size={18} />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto min-h-0 pr-2">
                {isImageLoading ? (
                  <div className="flex justify-center items-center h-full">
                    <span className="text-sm font-medium text-slate-500">Memuat data item...</span>
                  </div>
                ) : imageItems.length === 0 ? (
                  <div className="flex justify-center items-center h-full">
                    <span className="text-sm font-medium text-slate-500">Tidak ada item ditemukan.</span>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                    {imageItems.map((pi) => {
                      const item = pi.item;
                      if (!item) return null;
                      
                      // Handle gambar array or string
                      let imgUrl = '';
                      const imageBaseUrl = process.env.REACT_APP_PUBLIC_URL;
                      
                      let gData = item.gambar || item.gambar1;
                      
                      // Try to parse if it's a JSON string
                      if (typeof gData === 'string' && (gData.startsWith('[') || gData.startsWith('{'))) {
                        try {
                          gData = JSON.parse(gData);
                        } catch(e) {}
                      }

                      if (Array.isArray(gData) && gData.length > 0) {
                        imgUrl = `${imageBaseUrl}${gData[0].asli || gData[0]}`;
                      } else if (typeof gData === 'string' && gData.length > 0) {
                        imgUrl = gData.startsWith('http') ? gData : `${imageBaseUrl}${gData}`;
                      }

                      return (
                        <div key={pi.id} className="bg-slate-50 dark:bg-slate-700/30 rounded-xl overflow-hidden border border-slate-200 dark:border-slate-700 hover:shadow-md transition-shadow group flex flex-col h-full">
                          <div className="aspect-square bg-slate-100 dark:bg-slate-800 relative flex items-center justify-center overflow-hidden">
                            {imgUrl ? (
                              <img 
                                src={imgUrl} 
                                alt={item.kode_item} 
                                onClick={() => window.open(imgUrl, '_blank')}
                                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105 cursor-pointer"
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/300?text=No+Image' }}
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center text-slate-400">
                                <IconPhoto size={32} className="opacity-50 mb-2" />
                                <span className="text-[10px]">Belum Ada Gambar</span>
                              </div>
                            )}
                            <div className="absolute top-2 left-2 bg-amber-500 text-white text-[10px] font-bold px-2 py-0.5 rounded shadow">
                              {item.kode_item}
                            </div>
                          </div>
                          <div className="p-3 text-xs space-y-1.5 flex-1 flex flex-col justify-between">
                            <div>
                              <p className="font-bold text-slate-800 dark:text-slate-100 line-clamp-2">
                                {item.jenis_kategori?.kategori?.nama_kategori} - {item.jenis_kategori?.nama_jenis}
                              </p>
                              <p className="text-slate-500 dark:text-slate-400">{item.cabang?.nama_cabang}</p>
                            </div>
                            <div className="flex items-center justify-between pt-2 border-t border-slate-200 dark:border-slate-600 mt-2">
                              <span className="font-bold text-amber-600 dark:text-amber-400 bg-amber-50 dark:bg-amber-900/30 px-2 py-1 rounded-md">{item.karat} K</span>
                              <div className="text-right">
                                <p className="font-semibold text-slate-700 dark:text-slate-300">{parseFloat(item.berat).toFixed(3)} gr</p>
                                {item.harga_modal > 0 && (
                                  <p className="text-[10px] text-slate-500">{new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(item.harga_modal)}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>

              {imageLastPage > 1 && (
                <div className="flex justify-center items-center gap-2 pt-3 border-t border-slate-100 dark:border-slate-700 flex-shrink-0">
                  <button
                    disabled={imagePage === 1 || isImageLoading}
                    onClick={() => setImagePage(p => p - 1)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-lg border bg-white dark:bg-slate-700 hover:bg-slate-50 disabled:opacity-40 transition-colors"
                  >
                    Prev
                  </button>
                  <span className="text-xs font-bold text-slate-600 dark:text-slate-300 px-3 py-1 bg-slate-100 dark:bg-slate-800 rounded-lg">
                    {imagePage} / {imageLastPage}
                  </span>
                  <button
                    disabled={imagePage === imageLastPage || isImageLoading}
                    onClick={() => setImagePage(p => p + 1)}
                    className="px-3 py-1.5 text-xs font-semibold rounded-lg border bg-white dark:bg-slate-700 hover:bg-slate-50 disabled:opacity-40 transition-colors"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {showPinModalVerification && (
        <PinBrankas 
          onSuccess={() => {
            executeVerification();
          }}
        />
      )}
    </Layouts>
  );
};

export default VerifikasiPermohonanBrankas;
